<template>
  <div id="list-main" class="main service-new-list service-with-searchbar" :style="containerStyle" style="height: auto">
    <div id="overflow-scrolling-box" ref="scrollView" class="overflow-scrolling-box">
      <!-- 会员钻列表页专区入口 -->
      <ip-zone-list
        v-if="shopCategories === 'vip' && vipListZone && vipListZone.length"
        :zone-config-list="vipListZone"
        pf-structure="vip"
        :change-subscribe-promp="changeSubscribePromp"
      ></ip-zone-list>

      <!-- 影音文娱 泛娱乐专区入口 -->
      <ip-zone-list
        v-if="shopCategories === 'zone'"
        :zone-config-list="zoneConfigList"
        pf-structure="ipzone"
        :change-subscribe-promp="changeSubscribePromp"
      ></ip-zone-list>

      <div class="service-container">
        <!-- 大家都在充 -->
        <div id="top-recommend" ref="serviceContainer" class="mod-services">
          <h3 v-if="listRecommend && listRecommend.length" class="mod-service-lead-letter">大家都在充</h3>
          <div class="mod-list mod-list--link">
            <div v-for="(list, index) in listRecommend" :key="index" class="mod-list__item" role="button" @click="renderOrderPage(list)">
              <div v-show="list && list.adsId" class="mod-service">
                <div class="mod-service__hd">
                  <img v-lazy="list.url" class="mod-service__pic" aria-hidden="true" :alt="list.title" />
                </div>
                <div class="mod-service__bd">
                  <h4 class="mod-service__name">
                    {{ list.title }}
                    <!--<span class="mod-badge mod-badge--primary">{{list.tag}}</span>-->
                  </h4>
                  <p class="mod-service__desc">{{ list.summary }}</p>
                </div>
              </div>
              <div v-show="list && list.name && list.icon" class="mod-service">
                <div class="mod-service__hd">
                  <img v-lazy="list.icon" class="mod-service__pic" aria-hidden="true" :alt="list.name" />
                </div>
                <div class="mod-service__bd">
                  <h4 class="mod-service__name">
                    {{ list.name }}<i v-if="isPcGame(list) || isPcMonth(list)" class="icon icon-pc"></i>
                    <!-- <span class="mod-badge mod-badge--primary">{{list.tag}}</span>-->
                  </h4>
                  <!--<p class="mod-service__desc">{{list.description}}</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 按照字母顺序排列 -->
        <div v-for="(list, index) in serviceList" :id="list.char" :key="index" class="mod-services">
          <h3 v-if="list.list && list.list.length" class="mod-service-lead-letter">{{ list.char }}</h3>
          <div v-for="(item, index) in list.list" :key="index" class="mod-list mod-list--link" @click="renderOrderPage(item)">
            <div v-if="item" class="mod-list__item" role="button">
              <div class="mod-service">
                <div class="mod-service__hd">
                  <img v-lazy="item.icon" class="mod-service__pic" aria-hidden="true" :alt="item.name" />
                </div>
                <div class="mod-service__bd">
                  <h4 class="mod-service__name">
                    {{ item.name }}<i v-if="isPcGame(item) || isPcMonth(item)" class="icon icon-pc"></i>
                    <!--<span class="mod-badge mod-badge--primary">{{item.tag}}</span>-->
                  </h4>
                  <!--<p class="mod-service__desc">{{item.description}}</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SubscribePrompt ref="subscribePromptRef"></SubscribePrompt>

    <!-- 字母索引列表 -->
    <div
      v-if="serviceList && serviceList.length && serviceList.length >= 7"
      id="letters"
      class="mod-lead-letters mod-lead-letters--flexible"
      :style="letterStyle"
    >
      <template v-if="isHeightProper">
        <span
          v-if="listRecommend && listRecommend.length"
          :class="{ letter: true, 'letter--active': 'top-recommend' === currentCharacter }"
          data-id="top-recommend"
          >★<span :class="{ bubbles: true, 'bubbles--active': currentCharacter === '#' }">★</span></span
        >
        <span
          v-for="(list, index) in serviceList"
          :key="index"
          :data-id="list.char"
          :class="{ letter: true, 'letter--active': list.char === currentCharacter }"
        >
          {{ list.char }}
          <span :class="{ bubbles: true, 'bubbles--active': list.char === currentCharacter }">{{ list.char }}</span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import "es6-promise/auto"
import * as listApi from "../../api/list"
import * as reportDict from "../../constants/report-dictonary"
import * as userAgent from "../../utils/ua"
import * as url from "../../utils/url"
import * as enums from "../../store/enums"
import Raven from "raven-js"
import { throttle } from "../../utils/helper"

import IpZoneList from "./List/IpZoneList.vue"
import IpZoneItem from "./List/IpZoneItem.vue"
import SubscribePrompt from "../common/Subscribe/SubscribePrompt.vue"
import subscribeItem from "../mixins/subscribeItem"

export default {
  components: {
    IpZoneList,
    IpZoneItem,
    SubscribePrompt
  },

  mixins: [subscribeItem],
  props: ["shopCategories", "from", "css", "storeConfig"],

  data() {
    return {
      // 最开始的 currentCharacter 不能是 #
      currentCharacter: "*",
      distanceArr: [{ char: "top-recommend", offsetTop: 1 }],
      currentHeight: "",
      isFromTouched: false,
      charList: ["top-recommend"],
      isIos: false,
      serviceList: [],
      listRecommend: [],
      letterStyle: {
        height: "31em",
        top: this.css && this.css.top ? 115 + this.css.top + "px" : "85px"
      },
      containerStyle: {
        top: this.css && this.css.top ? this.css.top + "rem" : ".5rem"
      },
      serviceContainerHeight: "",

      zoneConfigList: [],
      ipZoneSort: []
    }
  },

  computed: {
    ...mapGetters(["userAgent", "loginState", "indexBiz", "gameListZone", "vipListZone", "pf"]),

    // 判断是否展示字母导航
    isHeightProper() {
      if (this.serviceContainerHeight <= 130 && this.serviceContainerHeight !== "") {
        return true
      } else {
        return false
      }
    },

    isIosQQ() {
      return this.userAgent.iOS && this.userAgent.QQ
    }
  },

  watch: {
    currentCharacter() {
      // 解决 ios&&qq 上，列表页渲染的问题
      if (this.isIosQQ && this.currentCharacter === "top-recommend") {
        this.$nextTick(() => {
          window.scrollTo(0, 1) // 触发页面滚动
        })
      }
    },
    $route: function (to) {
      // 本路由下路由变化
      if (to.path.indexOf("tabList") > -1 && to.query && to.query.tab === "zone") {
        this.parseZoneListSort(to.query)
        // 页面回到顶部
        if (to.query.firstIpZone) {
          setTimeout(() => {
            document.getElementById("overflow-scrolling-box") && document.getElementById("overflow-scrolling-box").scrollTo(0, 1)
          }, 0)
        }
      }
    }
  },

  /**
   * 渲染所有的列表，注意异步问题
   * distance function 的执行必须在 渲染 ok后
   * 否则会导致高度渲染不会计算准确
   */
  created() {
    this.setLoadingStart()

    let initActionList = []
    if (this.shopCategories === "zone") {
      initActionList.push(this.parseIpZoneConfig())
      initActionList.push(this.getIpZoneSort())
    } else {
      initActionList.push(this.setListRecommend({ storeConfig: this.storeConfig, shopCategories: this.shopCategories }))
      initActionList.push(this.setServiceList({ storeConfig: this.storeConfig, shopCategories: this.shopCategories }))
      if (this.shopCategories === "vip") {
        initActionList.push(this.getSmallIpZone())
      }
    }
    Promise.all(initActionList)
      .then(res => {
        if (this.shopCategories === "zone") {
          this.listRecommend = []
          this.ipZoneSort = (res && res.length && res[1]) || []
          this.zoneConfigList = (res && res.length && res[0]) || []
          this.parseZoneListSort(this.$route.query)
          if (res[0] && res[0].length) {
            let busList = []
            res[0].forEach(ipZoneConfig => {
              busList = busList.concat(ipZoneConfig.busList)
            })
            this.serviceList = listApi.handleListArray(null, null, this.loginState, busList)
          }
        } else {
          ;[this.listRecommend, this.serviceList] = res
        }

        this.setLoadingEnd()

        this.$nextTick(() => {
          this.bindEvents()
          this.initData()
          this.setDistanceArr()
          // 延时再设置一次，页面渲染完成后计算的高度才是正确的
          setTimeout(() => {
            this.setDistanceArr()
          }, 500)
          this.userScroll()
        })
      })
      .catch(err => {
        Raven.captureException(new Error("list-component-init-fail"), {
          tag: { type: "list-component-init-fail" },
          extra: {
            err
          }
        })
      })

    // 上报列表页曝光
    this.reportUserAction({
      iformat: `${reportDict.PAGE_VIEW.SERVICE_LIST}_${this.from || "default"}`,
      pfStructure: this.from
    })
  },

  /**
   * 记录离开时的页面高度，重新到 list page 时需要定位到此处
   * 上报 pv 及广告位的曝光，注意必须在 beforeRouteEnter 中进行
   */
  activated() {
    // 上报广告位曝光
    if (this.listRecommend && this.listRecommend.length && this.listRecommend[0].adsId) {
      this.reportUserAction({
        iformat: reportDict.PAGE_VIEW.SERVICE_LIST_ADS,
        pfStructure: this.from
      })
    }

    this.$nextTick(() => {
      if (this.isIos) {
        setTimeout(() => {
          if (this.currentHeight) {
            this.$refs.scrollView.scrollTop = this.currentHeight
          }
        }, 50)

        document.body.addEventListener("touchmove", this.callBackOfDocumentEvent)
      } else {
        if (this.currentHeight) {
          this.$refs.scrollView.scrollTop = this.currentHeight
        }
      }
    })
  },

  /**
   * 页面离开时清除页面的 scroll view touch handler
   * 并且设置 currentHeight 页面高度
   */
  deactivated() {
    this.currentHeight = this.$refs.scrollView.scrollTop ? this.$refs.scrollView.scrollTop : 1

    if (this.isIos) {
      document.body.removeEventListener("touchmove", this.callBackOfDocumentEvent)
    }
  },

  methods: {
    ...mapActions([
      "reportUserAction",
      "setLoadingStart",
      "setLoadingEnd",
      "goToOrderPage",
      "getSmallIpZone",
      "parseIpZoneConfig",
      "getIpZoneSort",
      "reportAndJump"
    ]),

    // 判断是否是电脑游戏
    isPcGame(item) {
      return item.categoryId == enums.BUSINESS_TYPE.PC_GAME
    },

    // 判断是否是端游的包月
    isPcMonth(item) {
      return item && item.shopCategories && item.shopCategories.indexOf("vip") !== -1 && item.shopCategories.indexOf("game") !== -1
    },

    // Set array sorted by Character
    setServiceList({ storeConfig, shopCategories }) {
      return new Promise(resolve => {
        // 列表排除哪些业务类型通过参数控制
        let excludeCategoryId = url.getParam("exclude_categoryid"),
          excludeCategoryIdArr = excludeCategoryId.split(",")

        let includeCategoryId = url.getParam("include_categoryid")
        // 过滤预约业务
        let hideReservation = url.getParam("hide_reservation")
        let result = listApi.handleListArray(storeConfig.itemList, shopCategories, this.loginState, null, hideReservation)
        let tempResult = []
        if (excludeCategoryId && excludeCategoryIdArr.length > 0) {
          result.forEach(group => {
            group.list = group.list.filter(biz => {
              // categoryId需要转成字符串,因为url上获取到的是字符串
              return excludeCategoryIdArr.indexOf(biz.categoryId.toString()) == -1
            })
            tempResult.push(group)
          })
        } else if (includeCategoryId) {
          result.forEach(group => {
            group.list = group.list.filter(biz => {
              // categoryId需要转成字符串,因为url上获取到的是字符串
              // 当includeCategoryId=1时，需要移除代币
              if (includeCategoryId == enums.BUSINESS_TYPE.MOBILE_GAME) {
                return biz.categoryId.toString() == includeCategoryId && biz.currency_type !== 2
              } else {
                return biz.categoryId.toString() == includeCategoryId
              }
            })
            tempResult.push(group)
          })
        } else {
          tempResult = result
        }
        resolve(tempResult)
      })
    },

    // Set list recommend by storeConfig
    setListRecommend({ storeConfig, shopCategories }) {
      return new Promise(resolve => {
        // 通过参数控制是否显示大家都在充
        if (url.getParam("hide_List_recommend")) {
          resolve([])
        } else {
          listApi.filterListRecommendByConfig(storeConfig, shopCategories, this.pf).then(result => {
            resolve(result)
          })
        }
      })
    },

    /**
     * 初始化 data 内部信息
     * isIos 判断是否是 ios 平台
     * firstLetterTop dom 渲染后计算第一个索引元素距离顶部的距离
     */
    initData() {
      if (userAgent.getUserAgent().iOS) {
        this.isIos = true
      }
    },

    // 定位到元素后滑动到当前的字母列表
    scrollToCharacter(letter) {
      let listEle = document.getElementById(letter),
        height = listEle.offsetTop

      this.currentCharacter = letter
      this.$refs.scrollView.scrollTop = height + 1
    },

    // 用户滚动页面时更新右边导航
    userScroll() {
      // 在这里加入 throttle

      function check() {
        let container = this.$refs.serviceContainer

        if (!this.isFromTouched) {
          this.currentCharacter = listApi.binarySearch(this.distanceArr, this.$refs.scrollView.scrollTop)
        }

        if (container) {
          // 记录“大家都在充”部分距离顶部的高度
          this.serviceContainerHeight = container.getBoundingClientRect().top
        }
      }

      this.$refs.scrollView.addEventListener("scroll", throttle(check, 500).bind(this))
    },

    // 计算每个字母所在的位置
    setDistanceArr() {
      this.serviceList.forEach(item => {
        this.distanceArr.push({
          char: item.char,
          offsetTop: document.getElementById(item.char) ? document.getElementById(item.char).offsetTop : 1
        })
      })
    },

    // 调到订单页
    renderOrderPage(item) {
      if (item.adsId) {
        this.reportUserAction({
          iformat: reportDict.CLICK.SERVICE_LIST_ADS,
          resultInfo: `adsId=${item.adsId}`,
          pfStructure: this.from
        })

        this.reportAndJump({
          target: item.link,
          iformat: reportDict.CLICK.SERVICE_LIST_ADS,
          resultInfo: `adsId=${item.adsId}`,
          pfStructure: this.from
        })
        return
      }

      this.goToOrderPage({
        groupId: item.groupId,
        busId: item.busId,
        query: {
          pfStructure: this.from
        }
      })

      this.reportUserAction({
        iformat: reportDict.CLICK.SERVICE_LIST,
        pfStructure: this.from
      })
    },

    /**
     * 绑定右侧字母滑动事件
     * 1. touchStart 记录当前的 letter 元素
     * 2. touchMove 定位当前的 letter 元素
     * 3. scrollToCharacter 滚动到相应的字母位置
     */
    bindEvents() {
      this.bindLettersEvent()

      if (this.isIos) {
        this.iosTouchHack()
      }
    },

    /**
     * 给 ios 绑定 hack 事件
     */
    iosTouchHack() {
      let wrapper = this.$refs.scrollView

      wrapper.addEventListener("touchmove", this.scrollViewTouchHandler, false)
      wrapper.addEventListener("touchstart", this.scrollViewTouchHandler, false)
    },

    /**
     * 处理 scroll view 的 touch 事件
     */
    scrollViewTouchHandler() {
      let wrapper = this.$refs.scrollView,
        scrollTop = wrapper.scrollTop,
        scrollHeight = wrapper.scrollHeight,
        clientHeight = wrapper.clientHeight

      if (scrollTop <= 0) {
        wrapper.scrollTop = 1
      } else if (scrollTop >= scrollHeight - clientHeight) {
        wrapper.scrollTop = scrollHeight - clientHeight - 1
      }
    },

    /**
     * 给 document touchmove 绑定的回调内容
     */
    callBackOfDocumentEvent() {
      if (this.currentCharacter) {
        let wrapper = document.body,
          scrollTop = wrapper.scrollTop

        if (scrollTop !== 0) {
          wrapper.scrollTop = 0
        }
      }
    },

    /**
     * 给索引字母绑定滑动事件
     */
    bindLettersEvent() {
      let letters = document.getElementById("letters")

      if (!letters) {
        return
      }

      letters.addEventListener("touchstart", e => {
        e.preventDefault()
        this.isFromTouched = true

        let target = e.target,
          letter = target.dataset.id

        if (letter) this.scrollToCharacter(letter)
      })

      letters.addEventListener("touchmove", e => {
        e.preventDefault()

        let letter = "",
          touched = e.targetTouches[0],
          element = document.elementFromPoint(touched.clientX, touched.clientY)

        if (element && (letter = element.dataset.id)) {
          if (this.currentCharacter === letter) return
          this.scrollToCharacter(letter)
        }
      })

      letters.addEventListener("touchend", () => {
        this.isFromTouched = false
      })
    },

    /**
     * 影音文娱列表排序
     */
    parseZoneListSort(query) {
      this.showIpZoneSort = [...this.ipZoneSort]
      if (query && query.tab === "zone" && query.firstIpZone && this.ipZoneSort && this.ipZoneSort.indexOf(query.firstIpZone) !== -1) {
        this.showIpZoneSort.splice(this.showIpZoneSort.indexOf(this.$route.query.firstIpZone), 1)
        this.showIpZoneSort.push(this.$route.query.firstIpZone)
      }
      // 根据推荐结果排序
      this.zoneConfigList.sort((item1, item2) => {
        // 结合反转的排序数组，实现indexOf结果为-1的排在最后面
        return -(this.showIpZoneSort.indexOf(String(item1.groupId)) - this.showIpZoneSort.indexOf(String(item2.groupId)))
      })
      let reportGroupId = 0
      if (this.zoneConfigList && this.zoneConfigList[0] && this.zoneConfigList[0].groupId) {
        reportGroupId = this.zoneConfigList[0].groupId
      }
      this.reportUserAction({
        iformat: `${reportDict.PAGE_VIEW.IPZONE_PAGESHOW}_${reportGroupId}`,
        pfStructure: this.$route.query.pfStructure
      })
    },

    showGameList() {
      this.$emit("changeSowGameZone")
      // this.isShowGameZone = false
    }
  }
}
</script>
